import React, { Fragment, useState } from 'react';
import {
  Button,
  Modal,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get } from '../../../services/back.service';

function ModalShowImagesCritical({ id }) {
  const [show, setShow] = useState(false);
  const [images, setImages] = useState([])

  const handleClose = () => setShow(false);

  const handleShow = async () => {
    const respo = await get(`/critical/images/${id}`, {}, {});
    console.log(`/critical/images/${id}`, respo)
    if (respo.success) {
      setImages(respo.data)
    }
    setShow(true);
  };

  return (
    <Fragment>
      <Button onClick={handleShow}>
        Ver Imagen
      </Button>

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Imagenes Anexas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Col>
              {
                images.map((image, i) =>
                  <Fragment>
                    <h5> Imagen {i + 1}</h5>
                    <Row className='mt-4'>
                      <img
                        alt="sin imagen"
                        src={image.image}
                      />
                    </Row>
                  </Fragment>
                )
              }
            </Col>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalShowImagesCritical;
